var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShangshuikou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 21",
    clipPath: "url(#clip0_30_731)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 5,
    y: 4,
    width: 6,
    height: 10,
    fill: "#15B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M2.15517 12.1538L3.23276 2H5V14H0V12.6154L2.15517 12.1538Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M13.8448 12.1538L12.7672 2H11V14H16V12.6154L13.8448 12.1538Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 555",
    d: "M7.99998 12.5L7.99998 8.5M7.99998 8.5L7.99998 7L9.05554 8.5L7.99998 8.5Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShangshuikou);
export default __webpack_public_path__ + "static/media/shangshuikou.38be818426cfa3949ddf3b786c3528d9.svg";
export { ForwardRef as ReactComponent };